import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DealComponent } from './deal.component';
import { DealCommentComponent } from './deal-comment.component';
import { DealResolver } from './deal-resolver.service';
import { MarkdownPipe } from './markdown.pipe';
import { SharedModule } from '../shared';
import { DealRoutingModule } from './deal-routing.module';
import {CarouselModule} from 'primeng/carousel';
import {EditorModule} from 'primeng/editor';
import {ButtonModule} from 'primeng/button';
import {PaginatorModule} from 'primeng/paginator';
import {SpeedDialModule} from 'primeng/speeddial';
import {SplitButtonModule} from 'primeng/splitbutton';
import {ToastModule} from 'primeng/toast';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {CategoryModule} from '../shared/layout/category.module';
import {MenuModule} from 'primeng/menu';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

@NgModule({
    imports: [
        SharedModule,
        DealRoutingModule,
        CarouselModule,
        EditorModule,
        ButtonModule,
        PaginatorModule,
        SpeedDialModule,
        SplitButtonModule,
        ToastModule,
        ConfirmDialogModule,
        CategoryModule,
        MenuModule,
        ProgressSpinnerModule
    ],
  declarations: [
    DealComponent,
    DealCommentComponent,
    MarkdownPipe
  ],

  providers: [
    DealResolver
  ]
})
export class DealModule {}
